/*
 * Shows a grey shimmer where a product picture will appear, until the picture
 * has arrived. The card text is already there, so the picture's place is clear
 * and nothing seems to pop in. The grey goes away completely once the picture
 * has loaded (square artwork leaves an empty strip under it, which stays clear).
 */
(function () {
  if (window.__sbfaCardImages) return;
  window.__sbfaCardImages = true;

  // Only boxes on screen shimmer; the rest stay plain grey, so a long list is cheap.
  const viewObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => entry.target.classList.toggle('sbfa-img-shimmer', entry.isIntersecting));
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  function watch(img) {
    if (img.dataset.sbfaWatched || (img.complete && img.naturalWidth > 0)) return;
    const box = img.closest('.card__media .media');
    if (!box) return;
    img.dataset.sbfaWatched = 'true';

    box.classList.add('sbfa-img-loading');
    if (viewObserver) viewObserver.observe(box);

    const done = () => {
      box.classList.remove('sbfa-img-loading', 'sbfa-img-shimmer');
      if (viewObserver) viewObserver.unobserve(box);
    };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  function scan(root) {
    if (root.matches && root.matches('.card__media .media img')) watch(root);
    root.querySelectorAll('.card__media .media img').forEach(watch);
  }

  scan(document);

  // Cards added later (the next batches as you scroll, or a restored list).
  const grid = document.getElementById('product-grid');
  if (grid) {
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(grid, { childList: true });
  }
})();
